interface ITrackingProduct {
  id: number;
  offerType: 'Builder';
  position: number;
  extra?: IExtra;
}

interface IExtra {
  house_id?: string;
}

/**
 * Возвращает данные аналитики для поля `products`.
 *
 * Аналогично функции `getAnalyticsPageCard` используется, как временное решение
 */
export const getAnalyticsProductsCard = (builderId: number, position: number, extra?: IExtra): ITrackingProduct[] => {
  return [
    {
      id: builderId,
      offerType: 'Builder',
      position,
      extra,
    },
  ];
};
